// Entrada por número (automação de entrada do funil padrão): o lead novo que
// chega por uma conexão cai direto numa etapa de qualquer funil, com roleta
// opcional. Pedido do número DESTRAVA da myCar (levantamento de 13/09). Funções
// puras, usadas pelo LabelConfigDrawer e pelo teste.

// Opções "Funil › Etapa", na ordem dos funis e das colunas.
export const opcoesDeEtapa = (funis, etapas) => {
  const porFunil = new Map(
    (Array.isArray(funis) ? funis : []).map((f, i) => [
      f.id,
      { nome: f.name || 'Funil', ordem: Number.isFinite(f.order) ? f.order : i },
    ])
  );
  return (Array.isArray(etapas) ? etapas : [])
    .filter((e) => e && e.id)
    .map((e) => {
      const funil = porFunil.get(e.pipeline_id);
      return {
        value: e.id,
        label: funil ? `${funil.nome} › ${e.name || 'Etapa'}` : (e.name || 'Etapa'),
        ordemFunil: funil ? funil.ordem : Number.MAX_SAFE_INTEGER,
        ordemEtapa: Number.isFinite(e.order) ? e.order : 0,
      };
    })
    .sort((a, b) => (a.ordemFunil - b.ordemFunil) || (a.ordemEtapa - b.ordemEtapa))
    .map(({ value, label }) => ({ value, label }));
};

// Etapa salva que saiu do catálogo continua no seletor, para o cliente ver e
// trocar. O motor já ignora etapa que não existe.
export const opcoesComSalva = (opcoes, labelId) => (
  !labelId || opcoes.some((o) => o.value === labelId)
    ? opcoes
    : [...opcoes, { value: labelId, label: 'Etapa não encontrada' }]
);

// Config salva -> estado da tela: {ref: {label_id, roulette_id}}. Aceita a
// forma curta {ref: 'label_id'} gravada por script.
export const lerMapaDeEntrada = (raw) => {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return {};
  return Object.entries(raw).reduce((acc, [ref, item]) => {
    const it = typeof item === 'string' ? { label_id: item } : item;
    if (ref && it && typeof it === 'object' && it.label_id) {
      acc[ref] = {
        label_id: String(it.label_id),
        roulette_id: it.roulette_id ? String(it.roulette_id) : '',
      };
    }
    return acc;
  }, {});
};

// Estado da tela -> payload. Conexão sem etapa sai do mapa (volta para a
// entrada padrão) e roleta vazia não vai.
export const mapaParaSalvar = (mapa) => Object.entries(mapa || {}).reduce((acc, [ref, it]) => {
  if (ref && it && it.label_id) {
    acc[ref] = it.roulette_id
      ? { label_id: it.label_id, roulette_id: it.roulette_id }
      : { label_id: it.label_id };
  }
  return acc;
}, {});

// Linhas da seção: as conexões do workspace e, depois delas, as que estão no
// mapa salvo mas não vieram na lista, para o cliente ver e limpar.
export const linhasDeConexao = (conexoes, mapa) => {
  const lista = (Array.isArray(conexoes) ? conexoes : []).filter((c) => c && c.ref);
  const vistas = new Set(lista.map((c) => c.ref));
  const fora = Object.keys(mapa || {})
    .filter((ref) => !vistas.has(ref))
    .map((ref) => ({
      ref, label: 'Conexão não encontrada', channel: null, phone: null, ausente: true,
    }));
  return [...lista, ...fora];
};
